import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

const deleteProductRequest: RequestExample = {
    title: {
        verb: 'DELETE',
        endpointUrl: '/api/products/:id',
    },
    curl:
        `curl --location \\
--request DELETE '<YOUR SERVER>/api/products/:id' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};
const deleteProductResponse: Json = {
    title: 'RESPONSE',
    json: '',
};

const data: RequestDefinitionData = {
    id: 'delete-product',
    title: 'Delete product',
    description: 'Deletes the product with the specified ID.',
    endpoint: {
        verb: 'DELETE',
        path: '/products/:id',
        tooltip: 'Delete product',
    },
    attributes: [],
    requestObject: deleteProductRequest,
    responseObject: deleteProductResponse,
};

export default data;
